import gql from 'graphql-tag';

export default gql`
  mutation adminUpdateApplications($input: AdminUpdateApplicationsInput!) {
    adminUpdateApplications(input: $input)
  }
`;
